import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { InformationWebScreen } from '@/features/bill-payment/screens/union-pay/InformationWeb.screen';
import { InformationNativeScreen } from '@/features/bill-payment/screens/union-pay/InformationNative.screen';

export interface InformationScreenProps {}

export const InformationScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.Information>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const {
    onLayout,
    onBack,
    transferPeer,
    wallet,
    calcFee,
    onChangeView,
    transferPeerCountFlag = true,
    unionType,
    refresh,
    navigationNavigate,
    navigationScreen
  } = route.params;

  if (layout.isMobile) {
    return (
      <InformationNativeScreen
        onBack={onBack}
        transferPeer={transferPeer}
        wallet={wallet}
        calcFee={calcFee}
        transferPeerCountFlag={transferPeerCountFlag}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  }
  return (
    <InformationWebScreen
      onLayout={onLayout}
      onBack={onBack}
      transferPeer={transferPeer}
      wallet={wallet}
      calcFee={calcFee}
      onChangeView={onChangeView}
      transferPeerCountFlag={transferPeerCountFlag}
      unionType={unionType}
      refresh={refresh}
      navigationNavigate={navigationNavigate}
      navigationScreen={navigationScreen}
    />
  );
};
